import React, { Component } from 'react';
import './style.scss'
import { connect } from 'react-redux'
import ItemImage from './components/ItemImage';
import ItemQuestion from './components/ItemQuestion';
import { Tabs, Tab } from 'react-bootstrap';
import QuestionsStudent from './components/QuestionsStudent';
import PropTypes from 'prop-types'
import AnswerStatistic from './components/AnswerStatistic';

const { TabPane } = Tabs;

class Slide extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  onChange = () => {

  }

  render() {
    const {formatMessage} = this.context;
    const {slide, session_id, item} =this.props;
    return (
      <div className="col-md-10">
      <div className="title-resentation">{item.name}</div>
    <Tabs defaultActiveKey="info" id="uncontrolled-tab-example">
      <Tab eventKey="info" title={formatMessage("txtPresentationSlideInfo")}>
        <div className="Slide">
          <div className="item">
            <div className="container-item">
              {slide && slide.type == 'image' && <ItemImage slide={slide} />}
              {slide && slide.type == 'question' && <ItemQuestion slide={slide} />}
            </div>
          </div>
        </div>
      </Tab>
      {session_id != 0 && <Tab eventKey="profile" title={formatMessage("txtPresentationQuestionsStudent")}>
        <QuestionsStudent session_id={session_id} />
      </Tab>}
      {session_id != 0 && <Tab eventKey="contact" title={formatMessage("txtPresentationAnswerStudentStatistic")}>
        <AnswerStatistic session_id={session_id} />
      </Tab>}
    </Tabs>

        {/* <Tabs defaultActiveKey="1" onChange={this.onChange}>
            <TabPane tab={formatMessage("txtPresentationSlideInfo")} key="1">
              <div className="Slide">
                <div className="item">
                  <div className="container-item">
                    {slide && slide.type == 'image' && <ItemImage slide={slide} />}
                    {slide && slide.type == 'question' && <ItemQuestion slide={slide} />}
                  </div>
                </div>
              </div>
            </TabPane>
            {session_id != 0 && <TabPane tab={formatMessage("txtPresentationQuestionsStudent")} key="2">
              <QuestionsStudent session_id={session_id} />
            </TabPane>}
            {session_id != 0 &&<TabPane tab={formatMessage("txtPresentationAnswerStudentStatistic")} key="3">
              <AnswerStatistic session_id={session_id} />
            </TabPane>}
          </Tabs> */}
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  slide: state.presentation.slide,
  item: state.presentation.item
})

const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(Slide)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Presentation/components/Slide/index.jsx